import Vue from "vue";
import { DateTime } from "luxon";
import { DATE_FORMAT, DATE_TIME_FORMAT, DATE_TIME_LONG_FORMAT, DATE_TIME_SHORT_FORMAT, DATE_LONG_FORMAT, TIME_FORMAT, DATE_DAY_FORMAT } from "@/Constants";

// Luxon-based filters to display the time exactly as sent from backend, respecting the offset

export function datetimeLongExact(date: string | null) {
  if (!date) return "";
  try {
    return DateTime.fromISO(date, { setZone: true }).toFormat(DATE_TIME_LONG_FORMAT);
  } catch (e) {
    return date;
  }
}
Vue.filter("datetimeLongExact", datetimeLongExact);

export function datetimeExact(date: string | null) {
  if (!date) return "";
  try {
    return DateTime.fromISO(date, { setZone: true }).toFormat(DATE_TIME_FORMAT);
  } catch (e) {
    return date;
  }
}
Vue.filter("datetimeExact", datetimeExact);

export function datetimeShortExact(date: string | null) {
  if (!date) return "";
  try {
    return DateTime.fromISO(date, { setZone: true }).toFormat(DATE_TIME_SHORT_FORMAT);
  } catch (e) {
    return date;
  }
}
Vue.filter("datetimeShortExact", datetimeShortExact);

export function dateExact(date: string | null) {
  if (!date) return "";
  try {
    return DateTime.fromISO(date, { setZone: true }).toFormat(DATE_FORMAT);
  } catch (e) {
    return date;
  }
}
Vue.filter("dateExact", dateExact);

export function dateLongExact(date: string | null) {
  if (!date) return "";
  try {
    return DateTime.fromISO(date, { setZone: true }).toFormat(DATE_LONG_FORMAT);
  } catch (e) {
    return date;
  }
}
Vue.filter("dateLongExact", dateLongExact);

export function timeExact(date: string | null) {
  if (!date) return "";
  try {
    return DateTime.fromISO(date, { setZone: true }).toFormat(TIME_FORMAT);
  } catch (e) {
    return date;
  }
}
Vue.filter("timeExact", timeExact);

export function dateDayExact(date: string | null) {
  if (!date) return "";
  try {
    return DateTime.fromISO(date, { setZone: true }).toFormat(DATE_DAY_FORMAT);
  } catch (e) {
    return date;
  }
}
Vue.filter("dateDayExact", dateDayExact);
// Backwards compatibility for legacy test name
Vue.filter("datedayExact", dateDayExact);
